<nav class="cabecera">
    <a class="regresar"><i class="fa fa-chevron-left" (click)="regresar()"></i></a>
    <h5>Agregar peso</h5>
    <a data-target="slide-out" class="sidenav-trigger"><i class="fa fa-bars"></i></a>
</nav>
<div class="container">
    <input type="hidden" id="orden" value="1">
    <h5>Registre los pesajes del {{prevtitle}} <strong>{{ corral }}</strong></h5>
    <div class="row">
        <div class="col s6 input-field container-semana">
            <span class="text-bold">Semana : </span>
            <input type="number" class="flow-text input-semana" [(ngModel)]="semana" (ngModelChange)="changeSemana()">
        </div>
        <div class="col s6 input-field">
            <span class="text-bold">STD : </span>
            <span class="flow-text">{{ STD }}</span>
        </div>

        <button class="btn waves-effect waves-light btn-simular" type="button" *ngIf="mostrarSimulacion" (click)="simular()">Generar simulación</button>

        <div class="input-field col s12">
            <table id="aves">
                <thead>
                    <tr>
                        <th>Aves</th>
                        <th width="70%">Peso</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let av of avesArray;let i = index">
                        <td>{{i + 1}}</td>
                        <td>
                            <input type="number" id="ave-{{i}}" [(value)]="av.peso" (keyup)="changeValueAve($event,i)" (keyup.enter)="saltar(i)">
                        </td>
                        <td *ngIf="i != 0">
                            <button class="btn red" (click)="eliminarAve(i)">-</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col s12" *ngIf="btnAgregarAves">
            <button class="btn waves-effect waves-light btn-large agregar-ave" type="button" (click)="saltar('ultimo')">Agregar ave</button>
        </div>
        <!-- <div class="col s12">
            <button class="btn waves-effect waves-light btn-large agregar-corral" type="button" (click)="registrarNext()">Guardar y continuar</button>
        </div> -->
        <div class="col s12">
            <button class="btn waves-effect waves-light btn-large agregar-corral" type="button" (click)="registrar()" *ngIf="semana != 0 && btnGuardar">Guardar</button>
        </div>
        <div class="col s12">
            <button class="btn waves-effect waves-light btn-large cancelar" type="button" (click)="cancelar()">Cancelar</button>
        </div>
    </div>
</div>
<!-- Modal Structure -->
<div id="modal1" class="modal">
    <div class="modal-content">
        <h4>{{ alert_message }}</h4>
    </div>
    <div class="modal-footer">
        <a class="modal-close waves-effect waves-green btn-flat confirmar" (click)="confirmar()">Confirmar</a>
        <a class="modal-close waves-effect waves-green btn-flat" (click)="close()">Cerrar</a>
    </div>
</div>
<!-- Error Modal Structure -->
<div id="modal2" class="modal">
    <div class="modal-content" style="background-color: #c51b1b;">
        <h4 class="white-text">{{ alert_message }}</h4>
    </div>
</div>
